import React from 'react';
import { InView } from 'react-intersection-observer';

import useEventTracking from '@hooks/useEventTracking';
import { ImpressionElement, impression } from '@tracking';

import OrgChartsGridItem from './GridItem';
import { OrgChartCompany } from './interfaces';
import styles from './styles.module.scss';

const OrgChartsGridView = ({ companies }: { companies: OrgChartCompany[] }) => {
  const { trackEvent } = useEventTracking();

  return (
    <InView
      triggerOnce={true}
      onChange={(inView) => {
        inView && trackEvent(impression({ impressionElement: ImpressionElement.OrgChartGridView }));
      }}
    >
      <div className={`grid w-full grid-cols-2 gap-0 sm:grid-cols-4 ${styles['unique-org-grid']}`}>
        {companies.map((company, index) => (
          <OrgChartsGridItem key={index} company={company} />
        ))}
        {companies.length === 0 && (
          <div className="col-span-2 sm:col-span-4">
            <p className="font-suisse-neue text-subheadline-sm">No companies found</p>
          </div>
        )}
      </div>
    </InView>
  );
};

export default OrgChartsGridView;
